import { useState } from 'react';
import { useSnackbar } from 'notistack';
import apiRequest from '../../../../api/request';

/**
 * Every write on the page goes through this: success shows the server's message and refreshes the page, a refusal shows the
 * server's own reason ("This overlaps time already logged…").
 *
 *   const [busy, run] = useSave(onChanged);
 *   run({ method: 'put', url: HOURS_URL, data }, afterSuccess);
 */
export default function useSave(onChanged) {
  const { enqueueSnackbar } = useSnackbar();
  const [busy, setBusy] = useState(false);

  const run = async (request, done) => {
    setBusy(true);
    const res = await apiRequest(request);
    setBusy(false);
    if (res?.status === 'success') {
      enqueueSnackbar(res.message || 'Saved', { variant: 'success' });
      if (done) done();
      onChanged();
    } else {
      enqueueSnackbar(res?.message || 'Could not save that - please try again', { variant: 'error' });
    }
  };

  return [busy, run];
}
